import { FC, ReactNode } from 'react';
import { cn } from '@/utils/classNames';

interface NavItem {
  icon: ReactNode;
  onClick?: () => void;
  label?: string;
}

interface BottomNavProps {
  items: NavItem[];
  className?: string;
  variant?: 'user' | 'admin';
}

const BottomNav: FC<BottomNavProps> = ({ items, className, variant = 'user' }) => {
  return (
    <nav className={cn(
      'fixed bottom-0 left-0 right-0 bg-white py-4 px-[51px] flex justify-between items-center lg:hidden',
      className
    )}>
      {items.map((item, index) => (
        <button
          key={index}
          onClick={item.onClick}
          className={cn(
            "flex flex-col items-center gap-1",
            variant === 'admin' ? 'text-gray-600 hover:text-gray-800' : 'text-primary hover:text-primary-dark'
          )}
        >
          {item.icon}
          {item.label && (
            <span className="text-xs">{item.label}</span>
          )}
        </button>
      ))}
    </nav>
  );
};

export default BottomNav; 